var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C4.11161 15 1.19223 9.9807 1.07088 9.76716C0.976375 9.60093 0.976375 9.39894 1.07088 9.2327C1.19223 9.0193 4.11161 4 10 4C15.8884 4 18.8078 9.0193 18.9291 9.23284C19.0236 9.39908 19.0236 9.60106 18.9291 9.7673C18.8078 9.9807 15.8884 15 10 15ZM2.22442 9.49918C2.89352 10.4907 5.52053 13.9 10 13.9C14.4937 13.9 17.109 10.4934 17.7756 9.50082C17.1065 8.50931 14.4795 5.1 10 5.1C5.50633 5.1 2.89098 8.50656 2.22442 9.49918ZM10 12.8C8.13897 12.8 6.625 11.3197 6.625 9.5C6.625 7.68033 8.13897 6.2 10 6.2C11.861 6.2 13.375 7.68033 13.375 9.5C13.375 11.3197 11.861 12.8 10 12.8ZM10 7.3C8.75941 7.3 7.75 8.28698 7.75 9.5C7.75 10.713 8.75941 11.7 10 11.7C11.2406 11.7 12.25 10.713 12.25 9.5C12.25 8.28698 11.2406 7.3 10 7.3Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.53c6014e2438165f5640b6b6d11b0938.svg";
export { ForwardRef as ReactComponent };